import type { JSX } from 'react';

const SIZES = {
  sm: 'h-4 w-4 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-[3px]',
} as const;

export function Spinner({
  size = 'md',
  label,
}: {
  size?: keyof typeof SIZES;
  label?: string;
}): JSX.Element {
  return (
    <span
      role={label ? 'status' : undefined}
      aria-label={label}
      className={`inline-block animate-spin rounded-full border-current border-t-transparent ${SIZES[size]}`}
    />
  );
}
